import { Env } from 'types/env/Env.type';

export const validateEnv = (envConfig: Partial<Env>, defaultConfig?: Partial<Env>): Env => {
  envConfig.apiUrl ||= defaultConfig?.apiUrl;
  if (!envConfig.apiUrl) throw new Error('API Url not defined in ENV config.');

  envConfig.routerBasePath ||= defaultConfig?.routerBasePath;
  envConfig.versionId = defaultConfig?.versionId;

  return envConfig as Env;
};
